const sentryEnvironment = process.env.REACT_APP_ENV;

export const SentryConfig = {
    sentryScope:
        'https://c409dec76ffa4ed6b8e080d901c552d2@o902103.ingest.sentry.io/6605579',
    sentryEnvironment,
    sentryRate: 0.5,
}